export const GOOGLE_LOADED = 'GOOGLE_LOADED';